import React from "react";
import { createRoot } from "react-dom/client";

import "@touchtech/baselayer-ui/dist/styles.css";
import "@touchtech/web-baselayer-ui/dist/styles.css";

import "@is/boot-flag";
import { markBootStage } from "@is/utils/bootCrumbs";

import App from "./app";

const container = document.getElementById("root");
const root = createRoot(container);
markBootStage("react-root-created");
root.render(<App />);
markBootStage("react-render-called");
